/**
 * Classe que gerencia o filtro do smartgeocode
 * @author: Adalto Junior adaltojunior@sagaranatech.com
 * DATE: 30/01/2013
 * @version 1.0
 *
 */


Greenmile.SmartGeocode = Greenmile.SmartGeocode || {};

Greenmile.SmartGeocode.Filter = function () {

    this.rootEl = null;
    this.fields = {};

    this.render = function () {

        var value = 0;
        var RADIUS_VALUE_DEFAULT = 40;
        var DRIVER_VALUE_DEFAULT = "";
        var LOCATION_VALUE_DEFAULT = "";
        var ORGANIZATION_VALUE_DEFAULT = "";
        var twoMonthsAgo = Monet.Format.Date.getFormattedLocaleToday({ monthsOffset: -2 });
        var today = Monet.Format.Date.getFormattedLocaleToday();
        var unitSystem = Monet.Session.User.unitSystem;

        if (Monet.Session.SmartGeocode) {
            RADIUS_VALUE_DEFAULT = Monet.Session.SmartGeocode["radius"];
            DRIVER_VALUE_DEFAULT = Monet.Session.SmartGeocode["driver"];
            LOCATION_VALUE_DEFAULT = Monet.Session.SmartGeocode["location"];
            ORGANIZATION_VALUE_DEFAULT = Monet.Session.SmartGeocode["organization"];

            value = RADIUS_VALUE_DEFAULT;
        } else {

            var formatter = new Monet.Format.DISTANCE(RADIUS_VALUE_DEFAULT);

            if (unitSystem !== "METRIC") {
                value = formatter.convertMetersToMiles().format().getValue();
            } else {
                value = formatter.convertMetersToKilometers().format().getValue();
            }
        }

        var radius = new Monet.UI.Fields.Decimal();
        var lookupDriver = new Monet.UI.Fields.PowerLookup();
        var lookupLocation = new Monet.UI.Fields.PowerLookup();
        var lookupOrganization = new Monet.UI.Fields.PowerLookup();
        var smartGeocodeDateRange = new Monet.UI.Fields.DateRange();
        var btnClear = new Monet.UI.Fields.Button();
        var btnFilter = new Monet.UI.Fields.Button();
        var bntGroupDiv = document.createElement("div");
        var sectionFilter = document.createElement("div");

        radius.setId("radius");
        radius.render();
        radius.rootEl.className = 'control-group';
        radius.setTextLabel(this.translateTitleRadius());
        radius.setInputName("radius");
        radius.setMandatory(false);
        radius.setDefaultValue(value);

        smartGeocodeDateRange.setId("smartGeocodeDateRange");
        smartGeocodeDateRange.render();
        smartGeocodeDateRange.rootEl.className = 'control-group';
        smartGeocodeDateRange.setTextLabel(Monet.I18n.getResourcesByKey('SmartGeocode.filter.dateRange'));
        smartGeocodeDateRange.setInputName("smartGeocodeDateRange");
        smartGeocodeDateRange.setMandatory(false);
        smartGeocodeDateRange.setValue({ini: twoMonthsAgo, fin: today});
        smartGeocodeDateRange.rootEl.className = 'control-group';


        const FILTER_NAMESPACE = 'SmartGeocode';

        lookupDriver.setId('driver_name');
        lookupDriver.setNameSpace(`${FILTER_NAMESPACE}Driver`);
        lookupDriver.setLayoutNameSpace(`Driver`);
        lookupDriver.setBaseSelector('#driver_name');
        lookupDriver.setMandatory(false);
        lookupDriver.setDisplayKey('name');
        lookupDriver.setLookUpEntity('Driver');
        lookupDriver.render();
        lookupDriver.setInputName('driver');
        lookupDriver.setTextLabel(
            Monet.I18n.getResourcesByKey('SmartGeocode.filter.driver')
        );
        lookupDriver.rootEl.className = 'control-group';
        lookupDriver.setValue(DRIVER_VALUE_DEFAULT);

        lookupLocation.setId('location_key');
        lookupLocation.setNameSpace(`${FILTER_NAMESPACE}Location`);
        lookupLocation.setLayoutNameSpace(`Location`);
        lookupLocation.setBaseSelector('#location_key');
        lookupLocation.setMandatory(false);
        lookupLocation.setDisplayKey('key');
        lookupLocation.setLookUpEntity('Location');
        lookupLocation.render();
        lookupLocation.setInputName('location');
        lookupLocation.setTextLabel(
            Monet.I18n.getResourcesByKey('SmartGeocode.filter.customer')
        );
        lookupLocation.setValue(LOCATION_VALUE_DEFAULT);

        lookupLocation.rootEl.className = 'control-group';
        bntGroupDiv.setAttribute("class", "btnGRoup");

        lookupOrganization.setId('organization_key');
        lookupOrganization.setNameSpace(`${FILTER_NAMESPACE}Organization`);
        lookupOrganization.setLayoutNameSpace(`Organization`);
        lookupOrganization.setBaseSelector('#organization_key');
        lookupOrganization.setMandatory(false);
        lookupOrganization.setDisplayKey('description');
        lookupOrganization.setLookUpEntity('Organization');
        lookupOrganization.render();
        lookupOrganization.setInputName('organization');
        lookupOrganization.setTextLabel(
            Monet.I18n.getResourcesByKey('SmartGeocode.filter.organization')
        );
        lookupOrganization.setValue(ORGANIZATION_VALUE_DEFAULT);

        lookupOrganization.rootEl.className = 'control-group';
        bntGroupDiv.setAttribute("class", "btnGRoup");

        btnClear.setId("btnFilterSmartGeocodeClear");
        btnClear.render();
        btnClear.setValue(Monet.I18n.getResourcesByKey("Map.FilterForm.clearBtn"));
        btnClear.setInputName("btn_clean");
        btnClear.setClassName('MonetUIFilterBuilderClearButton');
        btnClear.addEventClickListener(function () {
            radius.clear();
            lookupDriver.clear();
            lookupLocation.clear();
            lookupOrganization.clear();
            smartGeocodeDateRange.clear();
        });

        btnFilter.setId("btnFilterSmartGeocodeFilter");
        btnFilter.render();
        btnFilter.setValue(Monet.I18n.getResourcesByKey("Map.FilterForm.filterBtn"));
        btnFilter.setInputName("btn_filter");
        btnFilter.setClassName('MonetUIFilterBuilderFilterButton');
        btnFilter.addEventClickListener(function (context) {
            return function () {
                context.filterSmartGeocode();
            };
        }(this));

        bntGroupDiv.appendChild(btnFilter.rootEl);
        bntGroupDiv.appendChild(btnClear.rootEl);

        sectionFilter.setAttribute('id', 'filterSmartGeocode');
        sectionFilter.appendChild(radius.rootEl);
        sectionFilter.appendChild(lookupDriver.rootEl);
        sectionFilter.appendChild(lookupLocation.rootEl);
        sectionFilter.appendChild(smartGeocodeDateRange.rootEl);
        sectionFilter.appendChild(lookupOrganization.rootEl);
        sectionFilter.appendChild(bntGroupDiv);

        this.fields.radius = radius;
        this.fields.driver = lookupDriver;
        this.fields.location = lookupLocation;
        this.fields.smartGeocodeDateRange = smartGeocodeDateRange;
        this.fields.organization = lookupOrganization;
        this.rootEl = sectionFilter;

        return this.rootEl;
    };

    this.translateTitleRadius = function () {

        var unitySystemMetric = new Greenmile.Calculos.GeneralFunctions().getUnitSystemToColumnGrid();

        return Monet.I18n.getResourcesByKey("SmartGeocode.filter.radius") + " (" + unitySystemMetric + ")";

    };

    this.getRadiusOnMeters = function (value) {

        var unitSystem = Monet.Session.User.unitSystem;
        var radius = 0;
        if (unitSystem === "NON_METRIC") {
            radius = value / 0.00062137;
        } else {
            radius = value * 1000;
        }

        return radius;

    };

    this.getParametersToFilter = function () {

        var parameters = {
            firstResult: App.Forms.SmartGeocode.pagination.first,
            maxResults: App.Forms.SmartGeocode.pagination.max
        };
        var radius = this.fields.radius.getValue();
        var driver = this.fields.driver.getValue();
        var location = this.fields.location.getValue();
        var organization = this.fields.organization.getValue();
        var smartGeocodeDateRange = this.fields.smartGeocodeDateRange.getValue();

        if (!Monet.Session.SmartGeocode) {
            Monet.Session.SmartGeocode = {};
        }
        Monet.Session.SmartGeocode["radius"] = radius;
        Monet.Session.SmartGeocode["driver"] = driver;
        Monet.Session.SmartGeocode["location"] = location;
        Monet.Session.SmartGeocode["smartGeocodeDateRange"] = smartGeocodeDateRange;
        Monet.Session.SmartGeocode["organization"] = organization;

        if (radius) {
            parameters.radius = parseInt(this.getRadiusOnMeters(radius));
        }

        if (driver) {
            parameters.driverId = driver.id;
        }

        if (location) {
            parameters.locationId = location.id;
        }

        if (organization) {
            parameters.organizationId = organization.id;
        }

        if(smartGeocodeDateRange.ini !== "" && smartGeocodeDateRange.fin !== "") {
            parameters.fromDate = smartGeocodeDateRange.ini;
            parameters.toDate = smartGeocodeDateRange.fin;
        }

        return JSON.stringify(parameters);

    };

    this.filterSmartGeocode = function () {

        var view = App.Views.SmartGeocode;
        view.showGrid();

    };

};
